<template>
  <div class="page-body"
    v-loading="loading">
    <div v-if="showHeadButtons || (simpleSearch.label && simpleSearch.prop)"
      class="table-buttons">
      <el-input class="simple-search"
        v-if="simpleSearch.label && simpleSearch.prop"
        v-model="simpleForm[simpleSearch.prop]"
        :placeholder="'请输入' + simpleSearch.label"
        :clearable="true"
        size="small"
        @clear="simpleHandle">
        <el-button slot="append"
          size="small"
          icon="el-icon-search"
          @click="simpleHandle"></el-button>
      </el-input>
      <div :class="{'float-right': simpleSearch.label && simpleSearch.prop, 'have-right-btn':  !simpleSearch.label && $slots.rightBtn}"
        v-if="showHeadButtons">
        <template v-for="(item, key) in headButtons">
          <el-button v-if="$route.meta && $route.meta.buttons[item.id]"
            :key="key"
            :type="item.type"
            :icon="item.icon"
            :plain="item.plain"
            :round="item.round"
            size="small"
            :disabled="btnDisabled(item)"
            @click="buttonClick(item.method)">{{$route.meta.buttons[item.id]}}</el-button>
        </template>
      </div>
      <div class="float-right right-btn" v-show="$slots.rightBtn">
        <slot name="rightBtn"></slot>
      </div>
    </div>
    <!-- 表格 -->
    <el-table ref="table"
      :data="tableData"
      :height="tableHeight"
      :empty-text="emptyText"
      :stripe="stripe"
      :border="border"
      :row-class-name="rowClassName"
      :row-key="getRowKeys"
      @selection-change="handleSelectionChange"
      @select="handleSelectRow"
      @select-all="handleSelectAll"
      @row-click="rowClick">
      <template v-for="(item, key) in tableColumns">
        <!-- 展开和handle的expand不用做缺省，scope外面做，因为不知道要展示啥，自己做 -->
        <template v-if="item.type === 'expand' || item.prop === 'handle'">
          <el-table-column :key="key"
            :type="item.type"
            :align="item.align"
            :fixed="item.fixed"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.minWidth"
            :width="item.width"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <slot :name="item.prop || item.type"
                :row="scope.row"></slot>
            </template>
          </el-table-column>
        </template>
        <!-- selection和index不做缺省 -->
        <template v-else-if="item.type === 'index' || item.type === 'selection'">
          <el-table-column :key="key"
            :type="item.type"
            :align="item.align"
            :fixed="item.fixed"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.minWidth"
            :width="item.width"
            :selectable="selectable"
            :reserve-selection="true"
            show-overflow-tooltip>
          </el-table-column>
        </template>
        <!-- 列表项的插槽判断是否为空，为空做缺省 -->
        <template v-else-if="item.slot">
          <el-table-column :key="key"
            :type="item.type"
            :align="item.align"
            :fixed="item.fixed"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.minWidth"
            :width="item.width"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <slot v-if="scope.row[item.prop] || scope.row[item.prop] === 0 || item.showDefault"
                :name="item.prop || item.type"
                :row="scope.row"></slot>
              <template v-else>-</template>
            </template>
          </el-table-column>
        </template>
        <!-- 普通列表数据缺省处理 -->
        <template v-else>
          <el-table-column :key="key"
            :type="item.type"
            :align="item.align"
            :fixed="item.fixed"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.minWidth"
            :width="item.width"
            show-overflow-tooltip>
            <!-- 无数据的占位 -->
            <template slot-scope="scope">{{scope.row[item.prop] || scope.row[item.prop] === 0 ? scope.row[item.prop] : '-'}}</template>
          </el-table-column>
        </template>
      </template>
    </el-table>
    <!-- 分页 -->
    <div class="foot"
      v-if="pagination">
      <el-pagination @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="form.page"
        :page-size="form.size"
        :page-sizes="pageSizes"
        :total="total"
        :layout="pageLayout || 'total,prev, pager, next,jumper'">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '@/utils/requst.js'
import { mapGetters } from "vuex";
export default {
  name: 'TableTable',
  props: {
    height: {
      type: String,
      default: 'calc(100% - 40px)'// 减去底部分页
    },
    headButtons: {
      type: Array,
      default() {
        return []
      }
    },
    tableRequest: {
      required: true,
      type: Object,
      default() {
        return {
          method: 'get',
        }
      }
    },
    border: {
      type: Boolean,
      default: false
    },
    tableColumns: {
      required: true,
      type: Array
    },
    emptyText: {
      type: String,
      default: '暂无数据'
    },
    stripe: {
      type: Boolean,
      default: false
    },
    rowClassName: {
      type: [String, Function],
    },
    relateSearch: {
      type: Boolean,
      default: true
    },
    pagination: {
      default: true
    },
    simpleSearch: {
      default: () => {
        return {}
      }
    },
    pageLayout: {
      default: ''
    },
    pageSizes: {
      default: () => {
        return [10, 20, 30, 50, 100]
      }
    },
    selectedData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      selections: [],
      form: {
        page: 1,
        size: 10
      },
      query: {},
      simpleForm: {},
      total: 0,
      tableData: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      getTableQuery: 'getTableQuery'
    }),
    showHeadButtons() {
      // 传进来的头部按钮存在，并且都有权限
      if (this.headButtons.length === 0) return false

      // 权限判断
      return this.headButtons.some((btn) => {
        if (this.$route.meta && this.$route.meta.buttons) {
          return Object.keys(this.$route.meta.buttons).some((elem) => elem === btn.id)
        }
      })

    },
    tableHeight() {
      return this.showHeadButtons ? 'calc(100% - 75px)' : this.height // 减去头部按钮高度
    }
  },
  watch: {
    // 头部筛选参数变换，更新列表数据
    getTableQuery: {
      handler(newVal, oldVal) {
        if (this.relateSearch) {
          this.query = newVal
          this.resetPage()
          this.getList()
        }
      },
      deep: true
    },
  },
  mounted() {
    if (this.relateSearch) this.query = this.getTableQuery
    this.getList()
  },
  methods: {
    btnDisabled(item) {
      if (item.disabled) {
        return item.disabled
      } else {
        if (item.selection) {
          return this.selections.length > 0 ? false : true
        }
        return false
      }
    },
    getRowKeys(row) {
      return row.id;
    },
    // 重置页码，删除，添加，导入等会影响表格数量的操作重置；查看，编辑，导出等不影响数量的操作不建议重置
    resetPage() {
      this.form.page = 1
    },
    // 获取列表数据
    getList() {
      if (this.tableRequest && this.tableRequest.method && this.tableRequest.api) {
        this.loading = true
        let params = {}
        // 有分页加分页请求参数
        if (this.pagination) {
          params = Object.assign({}, this.form, (this.tableRequest.form || {}), this.query, this.simpleForm)
        } else {
          params = Object.assign({}, (this.tableRequest.form || {}), this.query, this.simpleForm)
        }

        api[this.tableRequest.method](this.tableRequest.api, params)
          .then(res => {
            // 有分页和无分页返回数据格式不同
            if (this.pagination) {
              this.tableData = res.list
              this.total = res.total
            } else {
              this.tableData = res
            }

            //列表渲染完毕后自定义操作
            this.$nextTick(() => {
              this.$emit('customOptions', res)
            })

            //反显多选
            this.setSelection()

          }).catch((error) => {
            throw error
          }).finally(() => {
            this.loading = false
          })
      } else if (this.tableRequest && this.tableRequest.apiModule && this.tableRequest.apiFun) {
        this.loading = true
        let params = {}
        // 有分页加分页请求参数
        if (this.pagination) {
          params = Object.assign({}, this.form, (this.tableRequest.form || {}), this.query, this.simpleForm)
        } else {
          params = Object.assign({}, (this.tableRequest.form || {}), this.query, this.simpleForm)
        }

        this.$api[this.tableRequest.apiModule][this.tableRequest.apiFun](params)
          .then(res => {
            // 有分页和无分页返回数据格式不同
            if (this.pagination) {
              this.tableData = res.data.list
              this.total = res.data.total

              this.$emit('ecbMap', res.ecbMap)
            } else {
              this.tableData = res.data
            }
            //列表渲染完毕后自定义操作
            this.$nextTick(() => {
              this.$emit('customOptions', res)
            })

            //反显多选
            this.setSelection()

          }).catch((error) => {
            throw error
          }).finally(() => {
            this.loading = false
          })
      }
    },
    // 分页页码改变
    handleCurrentChange(formPage) {
      this.form.page = formPage
      this.getList()
    },
    handleSizeChange(formSize) {
      this.form.page = 1
      this.form.size = formSize
      this.getList()
    },
    buttonClick(method) {
      // 如果有勾选的列，并且有别选中的
      if (this.selections.length > 0) {
        this.$emit(method, this.selections)
      } else {
        this.$emit(method)
      }
    },
    handleSelectionChange(val) {
      this.selections = val
      this.$emit('selectionChange', val)
    },
    handleSelectRow(selection, row) {
      this.$emit('handleSelectRow', selection, row)
    },
    handleSelectAll(selection) {
      this.$emit('handleSelectAll', selection)
    },
    simpleHandle() {
      this.resetPage()
      this.getList()
    },
    rowClick(row) {
      this.$emit('rowClick', row)
    },
    resetSearch() {
      this.simpleForm = {}
      this.getList()
    },
    //是否禁用选择框
    selectable(row, index) {
      let flag
      this.$emit('selectable', row, index, val => {
        flag = val
      })
      return flag !== undefined ? flag : true
    },
    //设置默认选中
    setSelection() {
      this.$nextTick(() => {
        if (this.selectedData.length) {
          this.selectedData.forEach(row => {
            let index = this.tableData.findIndex(item => item.id == row.id)
            if (index > -1) {
              this.$refs.table.toggleRowSelection(this.tableData[index], true);
            }
          })
        } else {
          this.$refs.table.clearSelection();
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.page-body {
  background: #fff;
  padding: 16px;
  height: calc(100% - 66px);
  position: relative;
  flex-shrink: 1;
  overflow-x: auto;
}
.table-buttons {
  margin-bottom: 12px;
  .simple-search {
    width: 325px;
  }
}

.have-right-btn {
  display: inline-block;
}
.right-btn {
  margin-bottom: 12px;
  margin-right: 12px;
}
</style>


// WEBPACK FOOTER //
// ../vue-common-laboratory/src/components/Table/TableTable/index.vue